var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FC6B21;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.3,59.1H17.7C6.8,59.1,0.5,52.9,0.5,42V22c0-10.9,6.3-17.1,17.2-17.1h28.6c10.9,0,17.2,6.2,17.2,17.1v20 C63.5,52.9,57.3,59.1,46.3,59.1z M17.7,10.6C10,10.6,6.2,14.3,6.2,22v20c0,7.7,3.8,11.4,11.5,11.4h28.6c7.7,0,11.5-3.7,11.5-11.4 V22c0-7.7-3.7-11.4-11.5-11.4H17.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.9,35.2c-2.6,0-5.1-0.8-7.1-2.4l-8.9-7.1c-1.2-1-1.4-2.8-0.4-4c1-1.2,2.8-1.4,4-0.4l8.9,7.1 c1.9,1.5,5.2,1.5,7.1,0l8.9-7.1c1.2-1,3-0.8,4,0.4c1,1.2,0.8,3-0.4,4L39,32.8C37,34.4,34.5,35.2,31.9,35.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.7b7e087f3bd32e3c6f02a469c587be86.svg";
export { ForwardRef as ReactComponent };